import React, { useState, useEffect } from "react";
import { useEventsAll } from "../util/db";
import AdminPageEventsRow from "./AdminPageEventsRow";
import { Card, Table } from "react-bootstrap";
import FormAlert from "./FormAlert";

function AdminPageEvents({ auth }) {
  //look up all events in db
  const {
    data: items,
    status: itemsStatus,
    error: itemsError,
  } = useEventsAll();

  // KP Leagues round selection - fetch once for all rows
  const [rounds, setRounds] = useState([]);
  const [loadingRounds, setLoadingRounds] = useState(false);

  // Fetch rounds from KP Leagues API once
  useEffect(() => {
    const fetchRounds = async () => {
      setLoadingRounds(true);
      try {
        const response = await fetch(
          "https://www.kpleagues.com/json_json/events.php",
          {
            method: "GET",
            headers: {
              "X-API-Key": process.env.REACT_APP_KP_LEAGUES_API_KEY,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        if (data.success && data.data) {
          // Filter to only show events with round_format_id 4, 5, or 9
          const filteredRounds = data.data.filter((round) =>
            ["4", "5", "9"].includes(round.round_format_id)
          );

          // Sort rounds: upcoming events first, then past events
          const today = new Date();
          today.setHours(0, 0, 0, 0); // Reset time to start of day for comparison

          const sortedRounds = filteredRounds.sort((a, b) => {
            const dateA = new Date(a.round_date);
            const dateB = new Date(b.round_date);
            // Check if dates are upcoming (today or future) or past
            const aIsUpcoming = dateA >= today;
            const bIsUpcoming = dateB >= today;

            // If one is upcoming and one is past, upcoming comes first
            if (aIsUpcoming && !bIsUpcoming) return -1;
            if (!aIsUpcoming && bIsUpcoming) return 1;

            // If both are upcoming, sort by date (earliest first)
            if (aIsUpcoming && bIsUpcoming) {
              return dateA - dateB;
            }

            // If both are past, sort by date (most recent first)
            return dateB - dateA;
          });

          setRounds(sortedRounds);
        }
      } catch (error) {
        console.log("Could not fetch rounds - CORS error on localhost:", error);
        // Set empty rounds array on CORS error
        setRounds([]);
      } finally {
        setLoadingRounds(false);
      }
    };
    fetchRounds();
  }, []);

  return (
    <>
      {itemsError && (
        <div className="mb-3">
          <FormAlert type="error" message={itemsError.message} />
        </div>
      )}

      {itemsStatus !== "loading" && items && items.length > 0 && (
        <Card
          className="mb-3"
          style={{
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <Card.Header
            style={{
              background: "#2D083F",
              color: "white",
              borderRadius: "10px 10px 0 0",
            }}
          >
            <Card.Title className="mb-0" style={{ color: "white" }}>
              Events
            </Card.Title>
          </Card.Header>
          <Card.Body style={{ background: "#FFFFFF", padding: "0" }}>
            <Table responsive className="table mb-0">
              <thead>
                <tr>
                  <th>Event Name</th>
                  <th>LD</th>
                  <th>Manage</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Round ID</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <AdminPageEventsRow
                    key={index}
                    item={item}
                    rounds={rounds}
                    loadingRounds={loadingRounds}
                  />
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      )}

      {itemsStatus !== "loading" && items && items.length === 0 && (
        <Card
          className="mb-3"
          style={{
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <Card.Header
            style={{
              background: "#2D083F",
              color: "white",
              borderRadius: "10px 10px 0 0",
            }}
          >
            <Card.Title className="mb-0" style={{ color: "white" }}>
              Events
            </Card.Title>
          </Card.Header>
          <Card.Body
            style={{ background: "#FFFFFF", borderRadius: "0 0 10px 10px" }}
          >
            <div className="text-center py-4">No events found.</div>
          </Card.Body>
        </Card>
      )}
    </>
  );
}

export default AdminPageEvents;
